export default __webpack_public_path__ + "static/media/blobs-no-1.069f1966.ogg";